import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"pa-0"},[_c(VForm,{ref:"form"},[_c(VAppBar,{staticClass:"elevation-0 pa-0 page-header-toolbar",attrs:{"color":"transparent"}},[_c('page-header-title',{attrs:{"title":_vm.$t('changelog.title')}})],1),_c(VContainer,{attrs:{"grid-list-md":""}},[_c(VCard,[_c(VCardText,{staticClass:"pa-4"},[_c(VLayout,{attrs:{"row":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":""}},[_c('pre',[_vm._v(_vm._s(_vm.content))])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }